(ns teamoesterreich.admin-mode.content.news-admin-list
  (:require [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.news :as d-news]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]

            [reagent-material-ui.icons.build :refer [build]]
            [reagent-material-ui.icons.add :refer [add]]

            ))



(defn time-conv [rest-time]
  (if (= "" (str rest-time))
    nil
    (js/Date. (str (subs rest-time 0 4) "-" (subs rest-time 4 6) "-" (subs rest-time 6 11) ":" (subs rest-time 11 13) ":" (subs rest-time 13 19) "-00:00"))))

(defn time-print [rest-time]
  (if (= "" (str rest-time))
    nil
    (let [d (time-conv rest-time)] (str (.toLocaleDateString d) " " (subs (.toLocaleTimeString d) 0 5)))))




(defn text-block-card [text !opened]
  (let [opened? (= @!opened (get text :news-uuid))
        type (get text :news-type)
        ]
    [mui/card {:style {:backgroundColor (if (get text :news-published) "" "#e6e6e5") :marginBottom "20px"}}
     [mui/card-header
      {:title
       (r/as-element [mui/grid
                      {:container  true
                       :direction  "row"
                       :alignItems "stretch"
                       :justify    "flex-start"
                       }
                      [mui/grid
                       {:item  true
                        :md    4
                        :xs    12
                        :style {:height "80px" :textAlign "left" :paddingLeft ""}
                        }
                       [:img {:src (:news-imageUri text) :alt "Kein Bild" :height "80"}]
                       ]

                      [mui/grid
                       {:item  true
                        :md    8
                        :xs    12
                        :style {:height "80px" :textAlign "left" :paddingLeft "20px"}
                        }
                       [mui/typography {:variant "h5"} (str (time-print (get text :news-date)) " - " (get text :news-title) (when-not (get text :news-published) " - [unveröffentlicht]"))]]]
                     )}]

     [mui/card-actions

      [mui/button {:startIcon (r/as-element [build])
                   :onClick   (fn []
                                (reset! !opened (get text :news-uuid))
                                (a/set-page :news-edit))
                   }
       "Bearbeiten"
       ]
      ]

     ]))

(defn get-it []
  (let [!news-list (r/cursor vstate/app-state [:news-list])
        !loaded? (r/cursor !news-list [:loaded])
        !data (r/cursor !news-list [:data])
        !opened (r/cursor !news-list [:opened])
        !show-create-modal (r/cursor !news-list [:create])
        reload-fn #(reset! !loaded? false)]
    (fn []
      (when-not @!loaded?
        (do
          (d-news/get-news-list
            (fn [response]
              (swap! !news-list assoc :loaded true :data response)))))


      [mui/paper
       {:style {:padding "10px" :marginTop "5px"}}


       [mui/grid
        {:container  true
         :direction  "row"
         :alignItems "stretch"
         :justify    "flex-start"
         :style      {:textAlign "left"}
         }
        [mui/grid
         {:item  true
          :xs    10
          :style {:height "50px"}
          }
         [mui/typography {:variant "h5" :style {:margin "12px 0 0 400px"}
                          :onClick reload-fn}
          "Artikel"]]

        [mui/grid
         {:item  true
          :xs    2
          :style {:height "50px"}
          }
         [ws-event-sync-component/ws-event-reload !loaded? :news]]


        [create-with-name-modal/modal !show-create-modal
         "Bitte gib einen Namen für die neue News ein"
         "Anlegen"
         (fn [name]
           (log/debug "Create news with Name: " name)
           (d-news/>new-news name (fn [new]
                                    (log/debug "Created news : " new)
                                    (reload-fn)
                                    (reset! !opened (:news-uuid new))
                                    (a/set-page :news-edit)
                                    ))
           )
         ]
        [mui/grid
         {:item  true
          :xs    12
          :style {:height "50px"}
          }
         [mui/button {:startIcon (r/as-element [add])
                      :variant   "outlined"
                      :color     "secondary"
                      :onClick   #(reset! !show-create-modal true)
                      }
          "Eine neue News anlegen"
          ]]

        (for [[uuid text] (reverse (sort-by (fn [[uuid n]] (:news-date n)) (filter (fn [[uuid n]] (:news-active n)) @!data)))]
          ^{:key (str "news-" uuid)}
          [mui/grid
           {:container false
            :item      true
            :xl        7
            :xs        12                                   ;extra-small: 0px
            }
           [text-block-card text !opened]
           ]
          )
        ]
       ]

      ))

  )

